import { request, success, failure, BD_PROJECT_DATA_REQUEST } from './utilities';
import { PostRequest } from '../api/genericApiCalls';
import { APP_SETTINGS } from '../../config';
import { GiConsoleController } from 'react-icons/gi';


export function GetCountriesAction(token) {
    return (dispatch) => {
        dispatch(request(BD_PROJECT_DATA_REQUEST.GET_COUNTRIE_REQUEST));
        PostRequest(APP_SETTINGS.API_PATH.BD_PROJECT_DATA.getCountries, null, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(BD_PROJECT_DATA_REQUEST.GET_COUNTRIE_SUCCESS, response.data.data));
                }
                else {
                    dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_COUNTRIE_FAILURE, response.data.message));
                }
            },
            error => {
                dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_COUNTRIE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}


export function GetWarmLeadsDataAction(reqObject, token) {
    return (dispatch) => {
        dispatch(request(BD_PROJECT_DATA_REQUEST.GET_WARM_LEADS_REQUEST));
        PostRequest(APP_SETTINGS.API_PATH.BD_PROJECT_DATA.getWarmLeads, reqObject, token).then(
            response => {
             
                if (response.data.status === 1) {
                    dispatch(success(BD_PROJECT_DATA_REQUEST.GET_WARM_LEADS_SUCCESS, response.data.data));
                }
                else {
                    dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_WARM_LEADS_FAILURE, response.data.message));
                }
            },
            error => {
                dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_WARM_LEADS_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}
export function GetStatesAction(countryId, token) {
    return (dispatch) => {
        dispatch(request(BD_PROJECT_DATA_REQUEST.GET_STATE_REQUEST));
        let path = `${APP_SETTINGS.API_PATH.BD_PROJECT_DATA.getStates}?countryId=${countryId}`;
        PostRequest(path, null, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(BD_PROJECT_DATA_REQUEST.GET_STATE_SUCCESS, response.data.data));
                }
                else {
                    dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_STATE_FAILURE, response.data.message));
                }
            },
            error => {
                dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_STATE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}

export function GetCitiesAction(countryId, token) {
    return (dispatch) => {
        dispatch(request(BD_PROJECT_DATA_REQUEST.GET_CITY_REQUEST));
        let path = `${APP_SETTINGS.API_PATH.BD_PROJECT_DATA.getCities}?stateId=${countryId}`;
        PostRequest(path, null, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(BD_PROJECT_DATA_REQUEST.GET_CITY_SUCCESS, response.data.data));
                }
                else {
                    dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_CITY_FAILURE, response.data.message));
                }
            },
            error => {
                dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_CITY_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}

export function GetProjectCategoryAction(token) {
    return (dispatch) => {
        dispatch(request(BD_PROJECT_DATA_REQUEST.GET_PROJECT_CATEGORY_REQUEST));
        PostRequest(APP_SETTINGS.API_PATH.BD_PROJECT_DATA.getProjectCategory, null, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(BD_PROJECT_DATA_REQUEST.GET_PROJECT_CATEGORY_SUCCESS, response.data.data));
                }
                else {
                    dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_PROJECT_CATEGORY_FAILURE, response.data.message));
                }
            },
            error => {
                dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_PROJECT_CATEGORY_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}

export function GetKeywordsAction(token) {
    return (dispatch) => {
        dispatch(request(BD_PROJECT_DATA_REQUEST.GET_KEYWORDS_REQUEST));
        PostRequest(APP_SETTINGS.API_PATH.BD_PROJECT_DATA.getKeywords, null, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(BD_PROJECT_DATA_REQUEST.GET_KEYWORDS_SUCCESS, response.data.data));
                }
                else {
                    dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_KEYWORDS_FAILURE, response.data.message));
                }
            },
            error => {
                dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_KEYWORDS_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}

export function GetTechKeywordsAction(token) {
    return (dispatch) => {
        dispatch(request(BD_PROJECT_DATA_REQUEST.GET_TECH_KEYWORDS_REQUEST));
        PostRequest(APP_SETTINGS.API_PATH.BD_PROJECT_DATA.getTechKeywords, null, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(BD_PROJECT_DATA_REQUEST.GET_TECH_KEYWORDS_SUCCESS, response.data.data));
                }
                else {
                    dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_TECH_KEYWORDS_FAILURE, response.data.message));
                }
            },
            error => {
                dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_TECH_KEYWORDS_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}

export function GetProjectsDataAction(token) {
    return (dispatch) => {
        dispatch(request(BD_PROJECT_DATA_REQUEST.GET_PROJECTS_DATA_REQUEST));
        PostRequest(APP_SETTINGS.API_PATH.BD_PROJECT_DATA.getProjectsData, null, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(BD_PROJECT_DATA_REQUEST.GET_PROJECTS_DATA_SUCCESS, response.data.data));
                }
                else {
                    dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_PROJECTS_DATA_FAILURE, response.data.message));
                }
            },
            error => {
                dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_PROJECTS_DATA_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}


export function GetLeadsPerPlatformAction(reqObject, token) {
    return (dispatch) => {
        dispatch(request(BD_PROJECT_DATA_REQUEST.GET_LEADS_PER_PLATFORM_REQUEST));
        PostRequest(APP_SETTINGS.API_PATH.BD_PROJECT_DATA.getLeadsPerPlatform, reqObject, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(BD_PROJECT_DATA_REQUEST.GET_LEADS_PER_PLATFORM_SUCCESS, response.data.data));
                }
                else {
                    dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_LEADS_PER_PLATFORM_FAILURE, response.data.message));
                }
            },
            error => {
                dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_LEADS_PER_PLATFORM_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}

export function GetBusinessPerAgentAction(reqObject, token) {
    return (dispatch) => {
        dispatch(request(BD_PROJECT_DATA_REQUEST.GET_BUSINESS_PER_AGENT_REQUEST));
        PostRequest(APP_SETTINGS.API_PATH.BD_PROJECT_DATA.getBusinessPerAgent, reqObject, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(BD_PROJECT_DATA_REQUEST.GET_BUSINESS_PER_AGENT_SUCCESS, response.data.data));
                }
                else {
                    dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_BUSINESS_PER_AGENT_FAILURE, response.data.message));
                }
            },
            error => {
                dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_BUSINESS_PER_AGENT_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}


export function LeadsGeneratedPerAgentAction(reqObject, token) {
    return (dispatch) => {
        dispatch(request(BD_PROJECT_DATA_REQUEST.LEADS_GENERATED_PER_AGENT_REQUEST));
        PostRequest(APP_SETTINGS.API_PATH.BD_PROJECT_DATA.leadsGeneratedPerAgent, reqObject, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(BD_PROJECT_DATA_REQUEST.LEADS_GENERATED_PER_AGENT_SUCCESS, response.data.data));
                }
                else {
                    dispatch(failure(BD_PROJECT_DATA_REQUEST.LEADS_GENERATED_PER_AGENT_FAILURE, response.data.message));
                }
            },
            error => {
                dispatch(failure(BD_PROJECT_DATA_REQUEST.LEADS_GENERATED_PER_AGENT_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}


export function ConversionPerAgentAction(reqObject, token) {
    return (dispatch) => {
        dispatch(request(BD_PROJECT_DATA_REQUEST.CONVERSION_PER_AGENT_REQUEST));
        PostRequest(APP_SETTINGS.API_PATH.BD_PROJECT_DATA.conversionPerAgent, reqObject, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(BD_PROJECT_DATA_REQUEST.CONVERSION_PER_AGENT_SUCCESS, response.data.data));
                }
                else {
                    dispatch(failure(BD_PROJECT_DATA_REQUEST.CONVERSION_PER_AGENT_FAILURE, response.data.message));
                }
            },
            error => {
                dispatch(failure(BD_PROJECT_DATA_REQUEST.CONVERSION_PER_AGENT_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}

export function ConversionTrendAction(reqObject, token) {
    return (dispatch) => {
        dispatch(request(BD_PROJECT_DATA_REQUEST.CONVERSION_TREND_REQUEST));
        PostRequest(APP_SETTINGS.API_PATH.BD_PROJECT_DATA.conversionTrend, reqObject, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(BD_PROJECT_DATA_REQUEST.CONVERSION_TREND_SUCCESS, response.data.data));
                }
                else {
                    dispatch(failure(BD_PROJECT_DATA_REQUEST.CONVERSION_PER_AGENT_FAILURE, response.data.message));
                }
            },
            error => {
                dispatch(failure(BD_PROJECT_DATA_REQUEST.CONVERSION_TREND_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}



export function GetQuarterlyDataAction(reqObject, token) {
    return (dispatch) => {
        dispatch(request(BD_PROJECT_DATA_REQUEST.QUARTERLY_DATA_REQUEST));
        PostRequest(APP_SETTINGS.API_PATH.BD_PROJECT_DATA.getQuarterlyData, reqObject, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(BD_PROJECT_DATA_REQUEST.QUARTERLY_DATA_SUCCESS, response.data.data));
                }
                else {
                    dispatch(failure(BD_PROJECT_DATA_REQUEST.QUARTERLY_DATA_FAILURE, response.data.message));
                }
            },
            error => {
                dispatch(failure(BD_PROJECT_DATA_REQUEST.QUARTERLY_DATA_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}

export function GetWarmLeadsListAction(reqObject, token) {
    return (dispatch) => {
        dispatch(request(BD_PROJECT_DATA_REQUEST.GET_WARM_LEADS_LIST_REQUEST));
        PostRequest(APP_SETTINGS.API_PATH.BD_PROJECT_DATA.getWarmLeadsList, reqObject, token).then(
            response => {

                if (response.data.status === 1) {
                    dispatch(success(BD_PROJECT_DATA_REQUEST.GET_WARM_LEADS_LIST_SUCCESS, response.data.data));
                }
                else {
                    dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_WARM_LEADS_LIST_FAILURE, response.data.message));
                }
            },
            error => {
                dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_WARM_LEADS_LIST_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}

export function ConversionTrend(reqObject, token) {
    return (dispatch) => {
        dispatch(request(BD_PROJECT_DATA_REQUEST.CONVERSION_TREND_REQUEST));
        PostRequest(APP_SETTINGS.API_PATH.BD_PROJECT_DATA.conversionTrend, reqObject, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(BD_PROJECT_DATA_REQUEST.CONVERSION_TREND_SUCCESS, response.data.data));
                }
                else {
                    dispatch(failure(BD_PROJECT_DATA_REQUEST.CONVERSION_PER_AGENT_FAILURE, response.data.message));
                }
            },
            error => {
                dispatch(failure(BD_PROJECT_DATA_REQUEST.CONVERSION_TREND_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}

export function GetProjectDataAction(projectId, token) {
    return (dispatch) => {
        dispatch(request(BD_PROJECT_DATA_REQUEST.GET_PROJECT_DATA_REQUEST));
        let path = `${APP_SETTINGS.API_PATH.BD_PROJECT_DATA.getProjectData}?ProjId=${projectId}`;
        PostRequest(path, null, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(BD_PROJECT_DATA_REQUEST.GET_PROJECT_DATA_SUCCESS, response.data.data));
                }
                else {
                    dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_PROJECT_DATA_FAILURE, response.data.message));
                }
            },
            error => {
                dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_PROJECT_DATA_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}

export function SaveProjectDataAction(object, token) {
    return (dispatch) => {
        dispatch(request(BD_PROJECT_DATA_REQUEST.SAVE_PROJECT_DATA_REQUEST));
        PostRequest(APP_SETTINGS.API_PATH.BD_PROJECT_DATA.saveProjectData, object, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(BD_PROJECT_DATA_REQUEST.SAVE_PROJECT_DATA_SUCCESS, response.data.data));
                }
                else {
                    dispatch(failure(BD_PROJECT_DATA_REQUEST.SAVE_PROJECT_DATA_FAILURE, response.data.message));
                }
            },
            error => {
                dispatch(failure(BD_PROJECT_DATA_REQUEST.SAVE_PROJECT_DATA_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}

export function DeleteProjectDataAction(projectId, token) {
    return (dispatch) => {
        dispatch(request(BD_PROJECT_DATA_REQUEST.DELETE_PROJECT_DATA_REQUEST));
        let path = `${APP_SETTINGS.API_PATH.BD_PROJECT_DATA.deleteProjectData}?projectId=${projectId}`;
        PostRequest(path, null, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(BD_PROJECT_DATA_REQUEST.DELETE_PROJECT_DATA_SUCCESS, response.data.data));
                }
                else {
                    dispatch(failure(BD_PROJECT_DATA_REQUEST.DELETE_PROJECT_DATA_FAILURE, response.data.message));
                }
            },
            error => {
                dispatch(failure(BD_PROJECT_DATA_REQUEST.DELETE_PROJECT_DATA_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}

export function CheckProjectEmailAction(email, token) {
    return (dispatch) => {
        dispatch(request(BD_PROJECT_DATA_REQUEST.CHECK_PROJECT_EMAIL_REQUEST));
        let path = `${APP_SETTINGS.API_PATH.BD_PROJECT_DATA.checkProjectEmail}?URL=${email}`;
        PostRequest(path, null, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(BD_PROJECT_DATA_REQUEST.CHECK_PROJECT_EMAIL_SUCCESS, response.data.message));
                }
                else {
                    dispatch(failure(BD_PROJECT_DATA_REQUEST.CHECK_PROJECT_EMAIL_FAILURE, response.data.message));
                }
            },
            error => {
                dispatch(failure(BD_PROJECT_DATA_REQUEST.CHECK_PROJECT_EMAIL_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}

export function CheckProjectPostURLAction(url, token) {
    return (dispatch) => {
        dispatch(request(BD_PROJECT_DATA_REQUEST.CHECK_PROJECT_POST_URL_REQUEST));
        let path = `${APP_SETTINGS.API_PATH.BD_PROJECT_DATA.checkProjectPostURL}?URL=${url}`;
        PostRequest(path, null, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(BD_PROJECT_DATA_REQUEST.CHECK_PROJECT_POST_URL_SUCCESS, response.data.data));
                }
                else {
                    dispatch(failure(BD_PROJECT_DATA_REQUEST.CHECK_PROJECT_POST_URL_FAILURE, response.data.message));
                }
            },
            error => {
                dispatch(failure(BD_PROJECT_DATA_REQUEST.CHECK_PROJECT_POST_URL_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}

export function CheckProjectPhoneNumberAction(phoneNumber, token) {
    return (dispatch) => {
        dispatch(request(BD_PROJECT_DATA_REQUEST.VERIFY_PROJECT_PHONE_REQUEST));
        let path = `${APP_SETTINGS.API_PATH.BD_PROJECT_DATA.verifyProjectPhoneNumber}?phone=${phoneNumber}`;
        PostRequest(path, null, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(BD_PROJECT_DATA_REQUEST.VERIFY_PROJECT_PHONE_SUCCESS, response.data.message));
                }
                else {
                    dispatch(failure(BD_PROJECT_DATA_REQUEST.VERIFY_PROJECT_PHONE_FAILURE, response.data.message));
                }
            },
            error => {
                dispatch(failure(BD_PROJECT_DATA_REQUEST.VERIFY_PROJECT_PHONE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}

export function SaveProjectAgentAllocationAction(object, token) {
    return (dispatch) => {
        dispatch(request(BD_PROJECT_DATA_REQUEST.SAVE_PROJECT_AGENT_ALLOCATION_REQUEST));
        PostRequest(APP_SETTINGS.API_PATH.BD_PROJECT_DATA.saveProjectAgentAllocation, object, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(BD_PROJECT_DATA_REQUEST.SAVE_PROJECT_AGENT_ALLOCATION_SUCCESS, response.data.data));
                }
                else {
                    dispatch(failure(BD_PROJECT_DATA_REQUEST.SAVE_PROJECT_AGENT_ALLOCATION_FAILURE, response.data.message));
                }
            },
            error => {
                dispatch(failure(BD_PROJECT_DATA_REQUEST.SAVE_PROJECT_AGENT_ALLOCATION_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}

export function DeleteProjectAgentAllocationAction(projectAgentAllocationId, token) {
    return (dispatch) => {
        dispatch(request(BD_PROJECT_DATA_REQUEST.DELETE_PROJECT_AGENT_ALLOCATION_REQUEST));
        let path = `${APP_SETTINGS.API_PATH.BD_PROJECT_DATA.deleteProjectAgentAllocation}?AgentTimeAllocationId=${projectAgentAllocationId}`;
        PostRequest(path, null, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(BD_PROJECT_DATA_REQUEST.DELETE_PROJECT_AGENT_ALLOCATION_SUCCESS, response.data.data));
                }
                else {
                    dispatch(failure(BD_PROJECT_DATA_REQUEST.DELETE_PROJECT_AGENT_ALLOCATION_FAILURE, response.data.message));
                }
            },
            error => {
                dispatch(failure(BD_PROJECT_DATA_REQUEST.DELETE_PROJECT_AGENT_ALLOCATION_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}

export function GetProjectAgentAllocationAction(projectAgentAllocationId, token) {
    return (dispatch) => {
        dispatch(request(BD_PROJECT_DATA_REQUEST.GET_PROJECT_AGENT_ALLOCATION_REQUEST));
        let path = `${APP_SETTINGS.API_PATH.BD_PROJECT_DATA.getProjectAgentAllocation}?AgentTimeAllocationId=${projectAgentAllocationId}`;
        PostRequest(path, null, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(BD_PROJECT_DATA_REQUEST.GET_PROJECT_AGENT_ALLOCATION_SUCCESS, response.data.data));
                }
                else {
                    dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_PROJECT_AGENT_ALLOCATION_FAILURE, response.data.message));
                }
            },
            error => {
                dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_PROJECT_AGENT_ALLOCATION_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}

export function GetProjectAgentAllocationListAction(object, token) {
    return (dispatch) => {
        dispatch(request(BD_PROJECT_DATA_REQUEST.GET_PROJECT_AGENT_ALLOCATION_LIST_REQUEST));
        PostRequest(APP_SETTINGS.API_PATH.BD_PROJECT_DATA.getProjectAgentAllocationList, object, token).then(
            response => {
                if (response.data.status === 1) {
                    dispatch(success(BD_PROJECT_DATA_REQUEST.GET_PROJECT_AGENT_ALLOCATION_LIST_SUCCESS, response.data.data));
                }
                else {
                    dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_PROJECT_AGENT_ALLOCATION_LIST_FAILURE, response.data.message));
                }
            },
            error => {
                dispatch(failure(BD_PROJECT_DATA_REQUEST.GET_PROJECT_AGENT_ALLOCATION_LIST_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)));
            }
        )
    }
}